import { useInfiniteQuery } from 'react-query';
import { useContext } from 'react';
import { AuthContext } from "../../Context/AuthContext";

const fetchFreightOfficers = async ({ pageParam = 1 }, token) => {
  const response = await fetch(`${process.env.REACT_APP_SERVER_URL}/users/frieghtmanager?page=${pageParam}`, {
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    },
  });

  if (!response.ok) {
    throw new Error('Failed to fetch Freight officers');
  }

  return response.json();
};

const useFetchFreightOfficers = () => {
  const { token } = useContext(AuthContext);

  return useInfiniteQuery(
    ['freightOfficers'], 
    ({ pageParam = 1 }) => fetchFreightOfficers({ pageParam }, token),
    {
      getNextPageParam: (lastPage) => {
        const { currentPage, totalFreightManagers } = lastPage;
        const totalPages = Math.ceil(totalFreightManagers / 10); 
        return currentPage < totalPages ? currentPage + 1 : undefined;
      },
    }
  );
};

export default useFetchFreightOfficers;







